"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TabStyles_1 = require("../styles/TabStyles");
var CheckBox_1 = require("./resources/CheckBox");
var CheckBoxMixed_1 = require("./resources/CheckBoxMixed");
var Clear_1 = require("./resources/Clear");
var DropdownArrow_1 = require("./resources/DropdownArrow");
var Expando_1 = require("./resources/Expando");
var IconDropdownArrow_1 = require("./resources/IconDropdownArrow");
var MenuItemArrow_1 = require("./resources/MenuItemArrow");
var MenuItemCheck_1 = require("./resources/MenuItemCheck");
var RadioButton_1 = require("./resources/RadioButton");
var Search_1 = require("./resources/Search");
var SliderHandle_1 = require("./resources/SliderHandle");
var SliderLeftHandle_1 = require("./resources/SliderLeftHandle");
var SliderRightHandle_1 = require("./resources/SliderRightHandle");
var StepperDown_1 = require("./resources/StepperDown");
var StepperLeft_1 = require("./resources/StepperLeft");
var StepperRight_1 = require("./resources/StepperRight");
var StepperUp_1 = require("./resources/StepperUp");
/**
 * For now, here's how to update these:
 * 1) Get the appropriate SVG file from Visual Design.
 * 2) Paste it into https://jakearchibald.github.io/svgomg/ with the default options, copy the minified code out.
 * 3) Paste that into https://www.base64encode.org/ and click "Encode".
 * 4) Ensure the <svg> element has `class="$state$"` and a <style> block for defining interactivity.
 * 5) Save to the resources/ folder and follow the pattern you see in here for other icons.
 */
var svgDataUriRegExp = /^data\:image\/svg\+xml/;
function encodeSvg(svg) {
    return svgDataUriRegExp.test(svg) ? svg : "data:image/svg+xml," + encodeURIComponent(svg);
}
exports.encodeSvg = encodeSvg;
// Enable for TFS 799296 - "Add *.svg Resources Back and Update Code Playground"
// function decodeSvg(encodedSvg: string): string {
//   return svgDataUriRegExp.test(encodedSvg) ? atob(encodedSvg.substr(26)) : encodedSvg;
// }
function formatSvg(svgImport, state) {
    if (state === void 0) { state = {}; }
    // tslint:disable-next-line:no-any
    var classList = Object.keys(state).filter(function (key) { return !!state[key]; }).join(' ');
    // FIXME need a different webpack loader to get rid of this, TFSID 793075
    return encodeSvg(svgImport.replace('$state$', classList));
}
exports.CheckBoxIcon = {
    height: 16,
    width: 16,
    padding: 1,
    icon: function (state) { return formatSvg(CheckBox_1.CheckBoxSvg, state); },
};
exports.CheckBoxMixedIcon = {
    height: 16,
    width: 16,
    padding: 1,
    icon: function (state) { return formatSvg(CheckBoxMixed_1.CheckBoxMixedSvg, state); },
};
exports.DropdownArrowIcon = {
    height: 18,
    width: 18,
    icon: function (state) { return formatSvg(DropdownArrow_1.DropdownArrowSvg, state); },
};
exports.IconDropdownArrowIcon = {
    height: 5,
    width: 7,
    icon: function (state) { return formatSvg(IconDropdownArrow_1.IconDropdownArrowSvg, state); },
};
exports.MenuItemArrowIcon = {
    height: 18,
    width: 18,
    icon: function (state) { return formatSvg(MenuItemArrow_1.MenuItemArrowSvg, state); },
};
exports.MenuItemCheckIcon = {
    width: 10,
    height: 10,
    icon: function (state) { return formatSvg(MenuItemCheck_1.MenuItemCheckSvg, state); },
    checkedItemPaddingLeft: TabStyles_1.TabStyles.Spacing.DefaultSpace * 2 + 10,
};
exports.RadioButtonIcon = {
    height: 16,
    width: 16,
    padding: 1,
    icon: function (state) { return formatSvg(RadioButton_1.RadioButtonSvg, state); },
};
exports.StepperUpIcon = {
    height: 11,
    width: 18,
    icon: function (state) { return formatSvg(StepperUp_1.StepperUpSvg, state); },
};
exports.StepperDownIcon = {
    height: 11,
    width: 18,
    icon: function (state) { return formatSvg(StepperDown_1.StepperDownSvg, state); },
};
exports.TextFieldClearIcon = {
    height: 12,
    width: 12,
    icon: function (state) { return formatSvg(Clear_1.ClearSvg, state); },
};
exports.SearchIcon = {
    height: 12,
    width: 12,
    icon: function (state) { return formatSvg(Search_1.SearchSvg, state); },
};
exports.SliderHandleIcon = {
    height: 20,
    width: 20,
    icon: function (state) { return formatSvg(SliderHandle_1.SliderHandleSvg, state); },
};
exports.SliderLeftHandleIcon = {
    height: 20,
    width: 20,
    icon: function (state) { return formatSvg(SliderLeftHandle_1.SliderLeftHandleSvg, state); },
    artworkOffsetFromRightSide: 4,
};
exports.SliderRightHandleIcon = {
    height: 20,
    width: 20,
    icon: function (state) { return formatSvg(SliderRightHandle_1.SliderRightHandleSvg, state); },
    artworkOffsetFromLeftSide: 2,
};
exports.ExpandoIcon = {
    height: 13,
    width: 13,
    icon: function (state) { return formatSvg(Expando_1.ExpandoSvg, state); },
};
exports.StepperLeftIcon = {
    height: 22,
    width: 18,
    icon: function (state) { return formatSvg(StepperLeft_1.StepperLeftSvg, state); },
};
exports.StepperRightIcon = {
    height: 22,
    width: 18,
    icon: function (state) { return formatSvg(StepperRight_1.StepperRightSvg, state); },
};
//# sourceMappingURL=Icons.js.map